'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Storage = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _getAppInfo2 = require('./getAppInfo');

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Storage = exports.Storage = function () {
  function Storage(storageName) {
    var invalidateVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _classCallCheck(this, Storage);

    var _getAppInfo = (0, _getAppInfo2.getAppInfo)(),
        name = _getAppInfo.name,
        buildVariant = _getAppInfo.buildVariant,
        version = _getAppInfo.version;

    this.appVersion = version;
    this.storageName = name + '-' + buildVariant + '-' + storageName;
    this.invalidateVersion = invalidateVersion;
    console.log('Storage: ', this.storageName);
  }

  _createClass(Storage, [{
    key: 'getKey',
    value: function getKey(key) {
      var data = window.localStorage.getItem(this.storageName + '-' + key);
      if (data == null) return null;
      data = JSON.parse(data);

      if (this.invalidateVersion && data.appVersion != this.appVersion) {
        return null;
      }

      return data.data;
    }
  }, {
    key: 'setKey',
    value: function setKey(key, data) {
      data = JSON.stringify({
        data: data,
        appVersion: this.appVersion
      });
      window.localStorage.setItem(this.storageName + '-' + key, data);
    }
  }]);

  return Storage;
}();